<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import CardContent from "../components/CardContent.svelte"
  import Navbar from "../components/Navbar.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"
  import Alert from "../components/Alert.svelte"

  let ips = []
  let ip = ""
  let comentario = ""

  let isLoading = false
  let isAdding = false

  let acciones = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  }

  const getIpsBloqueadas = async () => {
    isLoading = true
    const response = await apiFetch(`${BASE_URL}ip.php?action=getIpsBloqueadas`)
    const resp = await response.json()
    ips = resp
    isLoading = false
  }

  const bloquearIp = async () => {
    //Post
    if (!validarIp(ip)) {
      alert = {
        show: true,
        message: "Formato de IP inválido",
        status: "warning",
        time: 3000,
      }
      return
    }

    //Si existe la IP
    const existe = ips.find((r) => r.ip === ip.trim())
    if (existe) {
      alert = {
        show: true,
        message: "La IP ya está bloqueada",
        status: "warning",
        time: 3000,
      }
      return
    }

    isAdding = true
    let form_data = new FormData()
    form_data.append("ip", ip.trim())
    form_data.append("comentario", comentario.trim())
    form_data.append("session_id_usuario", $user.idUsuario)

    const response = await apiFetch(`${BASE_URL}ip.php`, {
      method: "POST",
      body: form_data,
    })

    const resp = await response.json()
    if (resp.status === "success") {
      alert = {
        show: true,
        message: "IP bloqueada correctamente",
        status: "success",
        time: 3000,
      }
      ip = ""
      comentario = ""
      getIpsBloqueadas()
    } else {
      alert = {
        show: true,
        message: resp.message || "Error al bloquear la IP",
        status: "danger",
        time: 3000,
      }
    }
    isAdding = false
    ip = ""
    comentario = ""
  }

  const validarIp = (ip) => {
    // Validar formato de IP
    const regex =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
    return regex.test(ip)
  }

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true
    }

    getIpsBloqueadas()
  })
</script>

{#if $user}I
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="IPs Bloqueadas">
      <div class="row g-2 mb-2">
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
          <input
            type="text"
            class="form-control"
            bind:value={ip}
            placeholder="IP"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
          <input
            type="text"
            class="form-control"
            bind:value={comentario}
            placeholder="Comentario"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
          {#if isAdding}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Bloqueando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={bloquearIp}>
              Bloquear
            </button>
          {/if}
        </div>
      </div>

      {#if alert.show}
        <Alert
          message={alert.message}
          status={alert.status}
          time={alert.time}
          on:close={() => (alert.show = false)}
        />
      {/if}

      <div class="table-responsive">
        {#if isLoading}
          <Spinner message="Cargando" />
        {:else if ips.length === 0}
          <p class="text-center text-secondary mt-2">
            · · · No hay IPs bloqueadas · · ·
          </p>
        {:else}
          <table class="table table-sm table-striped table-bordered small my-3">
            <thead>
              <tr class="text-secondary fw-normal">
                <th scope="col">IP</th>
                <th scope="col">Fecha de bloqueo</th>
                <th scope="col">Comentario</th>
                <th scope="col">IP</th>
                <th scope="col">Fecha de bloqueo</th>
                <th scope="col">Comentario</th>
              </tr>
            </thead>
            <tbody>
              {#each ips as r, i}
                {#if i % 2 === 0}
                  <tr>
                    <td>{r.ip}</td>
                    <td>{r.fecha ?? ""}</td>
                    <td>{r.comentario ?? ""}</td>
                    {#if ips[i + 1]}
                      <td>{ips[i + 1].ip}</td>
                      <td>{ips[i + 1].fecha ?? ""}</td>
                      <td>{ips[i + 1].comentario ?? ""}</td>
                    {/if}
                  </tr>
                {/if}
              {/each}
            </tbody>
          </table>
        {/if}
      </div>
    </CardContent>
  </div>
{/if}
